'use client'

/**
 * LiveMobileViewer — vista mobile di /live.
 * App-like, sfondo scuro, 3 pannelli reali in colonna.
 * Rimpiazza l'intera pagina marketing su schermi < lg.
 */

import { useAllLiveMatches, useSortedMatchIds } from '@/hooks/useLiveMatch'
import MatchCarousel from './MatchCarousel'
import { TeamId } from '@/types/match'
import LogoImage from '@/components/LogoImage'

export default function LiveMobileViewer() {
  const { states, connected } = useAllLiveMatches()
  const allIds = useSortedMatchIds(states)

  return (
    <div className="theme-surface-contrast min-h-[calc(100vh-64px)] flex flex-col relative overflow-hidden">

      {/* ── Background photo (blurred, dim) ──────────────────────────────────── */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: 'url(/images/Match-week.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center 30%',
          filter: 'blur(4px) brightness(0.7)',
          transform: 'scale(1.05)',
        }}
      />
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'var(--theme-surface-contrast)', opacity: 0.15 }} />

      {/* ── Top bar ────────────────────────────────────────────────────────────── */}
      <div className="relative z-10 flex items-center justify-between px-4 pt-6 pb-4">
        <div className="flex items-center gap-2.5">
          <LogoImage
            src="/Dinamo.png"
            alt="Dinamo Molfetta"
            width={28}
            height={28}
            className="opacity-80"
          />
          <div>
            <p className="font-display font-bold uppercase text-[#FE7200] text-[9px] tracking-widest leading-none">
              Dinamo Molfetta
            </p>
            <p className="font-display font-bold uppercase theme-text-contrast text-lg leading-none">
              Live
            </p>
          </div>
        </div>

        {/* Connection status */}
        <div className="flex items-center gap-1.5">
          {connected ? (
            <>
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-400" />
              </span>
              <span className="font-display font-bold uppercase tracking-widest text-green-400/70 text-[9px]">
                Connesso
              </span>
            </>
          ) : (
            <>
              <span className="w-2 h-2 rounded-full theme-text-soft animate-pulse" />
              <span className="font-display font-bold uppercase tracking-widest theme-text-soft text-[9px]">
                Offline
              </span>
            </>
          )}
        </div>
      </div>

      {/* ── Pannelli ───────────────────────────────────────────────────────────── */}
      <div className="relative z-10 flex-1 px-4 pb-6 mt-4">
        <MatchCarousel
          matches={allIds.flatMap((teamId) => {
            const state = states[teamId]
            return state && state.visible !== false ? [{ teamId: teamId as TeamId, state }] : []
          })}
          visibleCount={3}
        />
      </div>

      {/* ── Footer minimo ──────────────────────────────────────────────────────── */}
      <div className="relative z-10 border-t theme-divider px-4 py-3 flex items-center justify-center">
        <p className="font-display font-bold uppercase tracking-widest theme-text-soft text-[9px]">
          ASD Polisportiva Dinamo Molfetta · dal 2016
        </p>
      </div>

    </div>
  )
}
